import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Form, Row, Col } from "react-bootstrap";

// css
import styles from "../../../layout/Auth/Auth.module.scss";
import { Formik } from "formik";
import AppInputField from "components/shared/FormComponents/AppInputField";
import forgotPassSchema from "./ForgotPassForm.schema";
import LoadingButton from "components/shared/LoadingButton";
import { useForgotPasswordMutation } from "store/services/forgotPassword";
import { successMessageToast } from "helpers/common";
import { CheckCircle } from "react-feather";
import { LOGIN } from "config/paths";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [linkSent, setLinkSent] = useState(false)

  const [forgotPasswordSubmit, { isLoading }] = useForgotPasswordMutation();

  const handleSubmit = async (values) => {
    try {
      await forgotPasswordSubmit({
        email: values.email
      }).unwrap();
      setLinkSent(true)
      // navigate("/otp", { state: { username: values.email } });
      // successMessageToast("Reset password link has been sent to you registered email address.")
      // navigate("/login", { state: { username: values.email } });

    } catch (err) {
      console.error("Error in forgotPassword:", err);
    }
  }

  return (
    <>
      <Formik
        initialValues={{ email: '' }}
        validationSchema={forgotPassSchema}
        onSubmit={handleSubmit}
      >
        {({
          handleSubmit,
          values,
          isSubmitting,
        }) => (
          <Form className={`${styles.form} pt-2`} onSubmit={handleSubmit}>
            <div className="formInner position-relative px-lg-3">
              <div className="w-100 inner">
                <div className="top py-2 text-center">
                  <h4 className="m-0 fw-bold py-1">Forgot Password</h4>
                  {
                    linkSent ? <>
                      <p className="m-0 fw-sbold py-1">
                        {`An email has been sent to ${values?.email}`}
                      </p>
                      <p style={{ fontWeight: "500" }} className="m-0 py-1">
                        Tap the link in this email in order to reset your {" "}
                        <br className="d-lg-block d-none" /> password.
                      </p>
                    </> :
                      <p className="m-0 fw-sbold py-1">
                        Enter your email and we'll send you an email with{" "}
                        <br className="d-lg-block d-none" /> a link to reset you password.
                      </p>
                  }
                </div>
                <Row className="justify-content-center">
                  {
                    linkSent ? <Col className="text-center" lg="12">
                      <div style={{ padding: '30px' }}>
                        <CheckCircle size={100} color="#b46c9f" />
                        <Link to={LOGIN} className="mt-3 d-block themeClr">Return to Login</Link>
                      </div>

                    </Col> :
                      <>
                        <Col lg="12" className="my-2">
                          <label
                            htmlFor=""
                            className="form-label m-0 pb-1 text-muted fw-sbold"
                          >
                            Email address:
                          </label>
                          <AppInputField
                            name="email"
                            placeholder="john******@gmail.com"
                            className={`${styles.formControl} form-control`}
                          />
                        </Col>
                        <Col lg="8" className="my-2">
                          <div className={`${styles.btnWrpper} pt-4 text-center btnWrpper`}>
                            <LoadingButton
                              type="submit"
                              className="d-flex align-items-center justify-content-center w-100 commonBtn"
                              isLoading={isLoading}
                            >
                              Submit
                            </LoadingButton>
                            <Link to={LOGIN} className="mt-3 d-block themeClr">Return to Login</Link>
                          </div>
                        </Col>
                      </>
                  }
                </Row>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};
export default ForgotPassword;
